import React, { FunctionComponent } from 'react';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import Paper from '../Paper/Paper';
import { MenuStateButtonPropsModel } from './models/menu-state-button-props.model';

const MenuStateButton: FunctionComponent<MenuStateButtonPropsModel> = ({
  isOpen,
  onClick,
}: MenuStateButtonPropsModel) => {
  const contentBasedOnOpen: React.ReactElement = isOpen ? (
    <Paper
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        boxShadow: 'unset',
        borderRadius: 0,
        backgroundColor: 'transparent',
        transition: 'none',
      }}
      onClick={onClick}
      component="span"
    >
      <ArrowBackIosNewIcon
        sx={{
          color: theme => theme.palette.primary.main,
          width: '20px',
          height: '14px',
        }}
      />
      <Paper
        sx={{
          lineHeight: 1.5,
          marginLeft: '17px',
          boxShadow: 'unset',
          borderRadius: 0,
          backgroundColor: 'transparent',
          transition: 'none',
        }}
        component="span"
      >
        Collapse
      </Paper>
    </Paper>
  ) : (
    <ArrowForwardIosIcon
      sx={{
        color: theme => theme.palette.primary.main,
        cursor: 'pointer',
        width: '20px',
        height: '14px',
      }}
      onClick={onClick}
    />
  );

  return (
    <Paper
      component="div"
      sx={{
        display: 'inline-block',
        padding: '20px',
        maxHeight: '64px',
        boxShadow: 'unset',
        borderRadius: 0,
        backgroundColor: 'transparent',
        transition: 'none',
      }}
    >
      {contentBasedOnOpen}
    </Paper>
  );
};

export default MenuStateButton;
